module.exports = __webpack_public_path__ + "img/road-trip-2.2aa17c89.jpg";